import { type ReactNode } from 'react';
import { SchedulesApiContext } from './SchedulesApiContext';
import type { SchedulesApiClient } from './types';

export function SchedulesApiProvider({
  client,
  children,
}: {
  client: SchedulesApiClient;
  children: ReactNode;
}) {
  return (
    <SchedulesApiContext.Provider value={client}>
      {children}
    </SchedulesApiContext.Provider>
  );
}
